import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTimer } from '../hooks';
import media from '../style/media';
import { theme } from '../style/theme';
import { useMediaPredicate } from 'react-media-hook';

const TimerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.neutral.gray50};
  transition: all ${theme.transitions.normal};
`;

const Value = styled.div`
  font-size: ${theme.typography.fontSize.lg};
  color: ${theme.colors.neutral.gray800};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-feature-settings: 'tnum';
  letter-spacing: 0.5px;
  
  ${media.tablet`
    color: ${theme.colors.primary.main};
    font-size: ${theme.typography.fontSize['2xl']};
    font-weight: ${theme.typography.fontWeight.bold};
  `}
`;

const Label = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.neutral.gray600};
  font-weight: ${theme.typography.fontWeight.medium};
  margin-right: ${theme.spacing[2]};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Timer = ({ started, durationSeconds }) => {
  const isMediaTablet = useMediaPredicate('(min-width: 1000px)');
  const seconds = useTimer(started, durationSeconds);
  const formatMinutes = useCallback(
    (seconds) => ('0' + Math.floor(seconds / 60)).slice(-2),
    [seconds],
  );
  const formatSeconds = useCallback(
    (seconds) => ('0' + (seconds % 60)).slice(-2),
    [seconds],
  );

  const remainingSeconds = Math.max(0, durationSeconds - seconds);
  const formatRemainingMinutes = useCallback(
    (seconds) => ('0' + Math.floor(seconds / 60)).slice(-2),
    [remainingSeconds],
  );
  const formatRemainingSeconds = useCallback(
    (seconds) => ('0' + (seconds % 60)).slice(-2),
    [remainingSeconds],
  );

  return (
    <TimerWrapper>
      {!isMediaTablet && <Label>Duration:</Label>}
      <Value>
        {formatMinutes(seconds)}:{formatSeconds(seconds)}
        {started && (
          <span style={{
            fontSize: '0.8em',
            color: theme.colors.neutral.gray500,
            marginLeft: theme.spacing[2]
          }}>
            / {formatRemainingMinutes(remainingSeconds)}:{formatRemainingSeconds(remainingSeconds)}
          </span>
        )}
      </Value>
    </TimerWrapper>
  );
};

export default Timer;
